<div class="toolbar">
  <button (click)="toggleInline('bold')" title="Bold"><b>B</b></button>
  <button (click)="toggleInline('italic')" title="Italic"><i>I</i></button>
  <button (click)="toggleInline('strike')" title="Strikethrough"><s>S</s></button>

  <label title="Font color">A
    <input type="color" (input)="applyColor($event, false)" />
  </label>

  <label title="Background color">BG
    <input type="color" (input)="applyColor($event, true)" />
  </label>

  <select (change)="applyFontSize($event)" title="Font size">
    <option value="">Font size</option>
    <option value="12px">12</option>
    <option value="14px" selected>14</option>
    <option value="18px">18</option>
    <option value="22px">22</option>
    <option value="28px">28</option>
  </select>

  <button (click)="insertTablePrompt()">Insert Table</button>
  <button (click)="insertPageBreak()">Insert Page Break</button>
</div>

<!-- The editor -->
<div class="editor-wrapper">
  <div
    #editor
    class="editor"
    contenteditable="true"
    spellcheck="true"
    (keydown)="onKeyDown($event)"
    (input)="onInput($event)"
    (mouseup)="updatePageNumber()"
    (keyup)="updatePageNumber()"
  ></div>
</div>

<!-- simple footer showing page number based on caret position -->
<div class="page-footer">Page <span>{{ currentPage }}</span></div>
